import { useRef, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { Principles } from "../../Principles"
import { ScrollTo } from "react-scroll-to";


export const PrinciplesDiagram = (props) => {
    const { ScreenName, ScreenSearch } = props
    const navigate = useNavigate()
    const [searchparams] = useSearchParams()
    // const ScreenName = searchparams.get('ScreenName')
    const Name = searchparams.get('Name')
    const SubName = searchparams.get('SubName')
    const SubsecondName = searchparams.get('SubsecondName')

    const [BtnShow, setBtnShow] = useState(1);

    return (
        <>
 <div className="container-fluid">

            <div className="row col-lg-9 mx-auto my-5 mx-0 px-0" >

                <div className="col-12 cursor" >
                    <img src="Static/Assets/Img/Principles/1-01.png" alt="" className="Principles1 cursor" />
                </div>

                    <div class="row padding_left">
                     
                     {/* <div class="col cursor">
                            <img src="Static/Assets/Img/Principles/2-01.png" alt="" className="Principles2 cursor"
                            />
                        </div> */}
                        {/* <ScrollTo>
                            {({ scroll }) => (
                                <div class="col "
                                    onClick={(() => scroll({ y: 800 }))}
                                >
                                    <img src="Static/Assets/Img/Principles/3-01.png" alt="" className="Principles2"
                                        onClick={() => setBtnShow(1)}
                                    />
                                </div>
                            )}
                        </ScrollTo> */}

                            <div class="col ">
                                <img src="Static/Assets/Img/Principles/3-11.png" alt="" className="Principles2 cursor" />
                            </div>

                            <ScrollTo>
                                {({ scroll }) =>
                                (<div class="col" onClick={(() => scroll({ y: 800 }))}>
                                    <img src="Static/Assets/Img/Principles/6-01.png" alt="" className="Principles2"
                                        onClick={() => setBtnShow(2)}
                                    />
                                </div>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) =>
                                (<div class="col" onClick={(() => scroll({ y: 800 }))}>
                                    <img src="Static/Assets/Img/Principles/7-01.png" alt="" className="Principles2"
                                        onClick={() => setBtnShow(3)}
                                    />
                                </div>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <div class="col" onClick={(() => scroll({ y: 800 }))}>
                                        <img src="Static/Assets/Img/Principles/8-01.png" alt="" className="Principles2"
                                            onClick={() => setBtnShow(4)}
                                        />
                                    </div>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <div class="col" onClick={(() => scroll({ y: 800 }))}>
                                        {/* <img src="Static/Assets/Img/Principles/4-01.png" alt="" className="Principles2"
                                        onClick={() => setBtnShow(2)}
                                    /> */}
                                        <img src="Static/Assets/Img/Principles/4-11.png" alt="" className="Principles2"
                                            onClick={() => setBtnShow(5)}
                                        />
                                    </div>
                                )}
                            </ScrollTo>

                            {/* <ScrollTo>
                            {({ scroll }) => (
                                <div class="col" onClick={(() => scroll({ y: 800 }))}>
                                    <img src="Static/Assets/Img/Principles/5-11.png" alt="" className="Principles2"
                                        onClick={() => setBtnShow(6)}
                                    />
                                </div>
                            )}
                        </ScrollTo> */}

                            <div class="col">
                                <img src="Static/Assets/Img/Principles/5-11.png" alt="" className="Principles2 cursor" />
                            </div>

                            {/* <div class="col cursor">
                                <img src="Static/Assets/Img/Principles/9-01.png" alt="" className="Principles2 cursor"
                                />
                            </div> */}

                        
                    </div>
    
                <ScrollTo>
                    {({ scroll }) => (
                        <div className="col-12" onClick={(() => scroll({ y: 800 }))}>
                            <img src="Static/Assets/Img/Principles/11-111.png" alt="" className="Principles4"
                                onClick={() => setBtnShow(6)} />
                        </div>
                    )}
                </ScrollTo>

                <ScrollTo>
                    {({ scroll }) => (
                        <div className="col-12" onClick={(() => scroll({ y: 800 }))}>
                            <img src="Static/Assets/Img/Principles/11-1111.png" alt="" className="Principles4"
                                onClick={() => setBtnShow(7)} />
                        </div>
                    )}
                </ScrollTo>

                {/* 
                    {
                        ScreenName == "Principles of Insurance" && <div className="col-6 pt-2 d-none d-lg-block">

                            <p className='Relative_Position mb-0 cursor_pointer' id="princes" onClick={() => setBtnShow(1)}>
                                <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                <span className="Absolute_Position ps-2">1) CONTRACT OF INSURANCE</span></p>

                            <p className='Relative_Position mb-0 cursor_pointer' id="princes" onClick={() => setBtnShow(2)} style={{ left: '23vw' }} >
                                <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 cursor_pointer" />
                                <span className="Absolute_Position ps-3" >2) UTMOST GOOD FAITH</span></p>

                            <p className='Relative_Position cursor_pointer ms-5 mb-0 mt-1' id="princes" onClick={() => setBtnShow(3)}>
                                <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                <span className="Absolute_Position ps-5">3) INDEMNITY</span></p>

                            <p className='Relative_Position mb-0 cursor_pointer' id="princes" onClick={() => setBtnShow(4)} style={{ left: '27vw' }}>
                                <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 cursor_pointer" />
                                <span className="Absolute_Position ps-4" >4) INSURABLE INTEREST</span></p>

                            <p className='Relative_Position cursor_pointer mb-0 mt-1' id="princes" style={{ marginLeft: '90px' }} onClick={() => setBtnShow(5)}>
                                <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                <span className="Absolute_Position ps-5">5) CONTRIBUTION</span></p>

                            <p className='Relative_Position  cursor_pointer mb-0' id="princes" onClick={() => setBtnShow(6)} style={{ left: '29vw' }}>
                                <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 cursor_pointer" />
                                <span className="Absolute_Position ps-5" >6) SUBROGATION</span></p>

                            <p className='Relative_Position cursor_pointer mb-0 mt-1' id="princes" style={{ marginLeft: '150px' }} onClick={() => setBtnShow(7)}>
                                <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                <span className="Absolute_Position ps-3" >7) RETURN OF PREMIUM</span></p>


                        </div>
                    } */}


            </div>
            </div>



            {/* {
                ScreenName == "Principles of Insurance" && */}
            <Principles
                BtnShow={BtnShow}
            />
            {/* } */}


        </>
    )
}
